import { Injectable } from '@angular/core';
import {
  DwDecoratorType,
  DwGridColumn,
  DwGridColumnDef,
  DwGridColumnRendererBase
} from '@devwareapps/devware-cap';
import { FlightSchoolExaminerEntity } from '../../../meta-data/app-meta-data.service';

@DwGridColumn({
  keyName: 'unit-member-training-current-column',
  display: 'Unit Member Training Current Status',
  decoratorType: DwDecoratorType.service,
  isGlobal: true,
  allowAction: false,
  showActionButtonConfig: false,
  requireAction: false,
  allowAttr: true,
  requireAttr: true,
  columnStyleFunc: () => ({ textAlign: 'center' })
})
@Injectable()
export class UnitMemberTrainingCurrentColumnRendererService implements DwGridColumnRendererBase {
  renderColumn(_columnConfig: DwGridColumnDef): (params: any) => string {
    return (params: any) => {
      const member = (params.data || {}) as FlightSchoolExaminerEntity;
      const current = params.getValue() === true;
      const reason = member.TrainingCurrentReason ||
        (current
          ? 'All required training is complete and current.'
          : 'Required training is missing, incomplete, or expired.');

      if (current) {
        return this.template('fa fa-check-circle dw-green', 'Current', reason);
      }

      const label = reason.indexOf('Expired:') >= 0 ? 'Expired' : 'Missing';
      return this.template('fa fa-exclamation-circle dw-red', label, reason);
    };
  }

  private template(iconClass: string, label: string, tooltip: string): string {
    return `<span class="unit-member-training-status" title="${this.escape(tooltip)}">` +
      `<i class="${iconClass}" aria-hidden="true"></i> ${this.escape(label)}</span>`;
  }

  private escape(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
